export default __webpack_public_path__ + "static/media/PalisadesMap.41e0095b.jpg";